export const CART_SCHEMA = 'iglu:com.psykhe/cart/jsonschema/1-0-0';
export const ECOMMERCE_ACTION_SCHEMA = 'iglu:com.psykhe/ecommerce_action/jsonschema/1-0-0';
export const CHECKOUT_STEP_SCHEMA = 'iglu:com.psykhe/checkout_step/jsonschema/1-0-0';
export const PRODUCT_SCHEMA = 'iglu:com.psykhe/product/jsonschema/1-0-0';
export const PAGE_SCHEMA = 'iglu:com.psykhe/page/jsonschema/1-0-0';
export const SEARCH_SCHEMA = 'iglu:com.psykhe/search/jsonschema/1-0-0';
export const USER_SCHEMA = 'iglu:com.psykhe/user/jsonschema/1-0-0';
export const TRANSACTION_SCHEMA = 'iglu:com.psykhe/transaction/jsonschema/1-0-0';
export const REFUND_SCHEMA = 'iglu:com.psykhe/refund/jsonschema/1-0-0';
export const PSYKHE_RECOMMENDATIONS_SCHEMA = 'iglu:com.psykhe/recommendations/jsonschema/1-0-0';
export const PSYKHE_PRODUCT_DWELL_TIME_SCHEMA = 'iglu:com.psykhe/product_dwell_time/jsonschema/1-0-0';



// WEBPACK FOOTER //
// ./~/@psykhe-ai/browser-plugin-snowplow-ecommerce/dist/schemata.js